import React from 'react';
import EmailIcon from '../icons/EmailIcon';
import PhoneIcon from '../icons/PhoneIcon';
import GlobeIcon from '../icons/GlobeIcon';
import NotAvailable from '../Common/NotAvailable';
import { toSafeHref } from '../../utils/url';

// Only what the provider entered; providers have no social media fields.
// Email is only passed for the user's own profile (it isn't public).
export interface ContactInfo {
  email?: string | null;
  phone?: string | null;
  website?: string | null;
}

export interface Certification {
  title: string;
  issuer?: string;
  year?: string;
}

interface ProviderContactInfoProps {
  certifications: Certification[];
  affiliations: string[];
  contact: ContactInfo;
}

const ProviderContactInfo: React.FC<ProviderContactInfoProps> = ({
  certifications,
  affiliations,
  contact,
}) => {
  return (
    <div className="grid grid-cols-3 gap-6">
      <div>
        <h4 className="font-['Ovo'] text-lg text-[#1f1f1f] uppercase mb-3">CERTIFICATIONS</h4>
        {certifications.length === 0 ? (
          <NotAvailable className="text-sm" />
        ) : (
          <div className="space-y-3">
            {certifications.map((cert, index) => (
              <div key={index} className="text-sm font-['Open_Sans'] text-[#767472]">
                <p className="font-semibold text-[#1f1f1f]">{cert.title}</p>
                {cert.issuer && <p>{cert.issuer}</p>}
                {cert.year && <p>{cert.year}</p>}
              </div>
            ))}
          </div>
        )}
      </div>

      <div>
        <h4 className="font-['Ovo'] text-lg text-[#1f1f1f] uppercase mb-3">AFFILIATIONS</h4>
        {affiliations.length === 0 ? (
          <NotAvailable className="text-sm" />
        ) : (
          <div className="space-y-2 text-sm font-['Open_Sans'] text-[#1f1f1f]">
            {affiliations.map((affiliation) => (
              <p key={affiliation}>{affiliation}</p>
            ))}
          </div>
        )}
      </div>

      <div>
        <h4 className="font-['Ovo'] text-lg text-[#1f1f1f] uppercase mb-3">CONTACT INFO</h4>
        <div className="space-y-2">
          {contact.email && (
            <div className="flex items-center gap-2">
              <EmailIcon />
              <a
                href={`mailto:${contact.email}`}
                className="font-['Open_Sans'] text-sm text-[#1f1f1f] hover:text-[#c6a664]"
              >
                {contact.email}
              </a>
            </div>
          )}
          <div className="flex items-center gap-2">
            <PhoneIcon />
            {contact.phone ? (
              <a
                href={`tel:${contact.phone}`}
                className="font-['Open_Sans'] text-sm text-[#1f1f1f] hover:text-[#c6a664]"
              >
                {contact.phone}
              </a>
            ) : (
              <NotAvailable className="text-sm" />
            )}
          </div>
          <div className="flex items-center gap-2">
            <GlobeIcon />
            {contact.website ? (
              <a
                href={toSafeHref(contact.website) || undefined}
                className="font-['Open_Sans'] text-sm text-[#1f1f1f] hover:text-[#c6a664]"
              >
                {contact.website}
              </a>
            ) : (
              <NotAvailable className="text-sm" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderContactInfo;
